


















import {userStore} from '@/store'
import {ref, reactive, computed, defineComponent, watchEffect, onMounted} from '@vue/composition-api'

export default defineComponent({
  name: 'FollowCamTrack',
  props: {
  },
  setup(props, context) {
    const active = computed(() => userStore.profile?.ui.shotDesigner.followCameraTrackMode || false)

    function switchMode() {
      console.log(`switchMode(${active.value})`)
      if (userStore.profile)
        userStore.setFollowCameraTrack(!(active.value))
    }

    const tooltip = computed(() => {
      return active.value ?
        'Following locked camera track; no manual camera control.<br>Click to free-orbit camera.'
        : 'Free-orbit camera, ignoring camera track.<br>Click to follow camera track.'
    })

    type breakpointName = keyof typeof context.root.$vuetify.breakpoint
    /** get a Vuetify breakpoint. Usage: bp('sm') return boolean */
    const bp = computed(() => {
      return (size: breakpointName) => context.root.$vuetify.breakpoint[size]
    })

    return {active, switchMode, bp, tooltip}
  }
})
